const blenderProjects = [
    {
      title: "Bowser's Castle",
      description: "A 3D environment study recreating the exterior of Bowser’s Castle, focused on translating a stylized game location into a cinematic scene.",
      image: "/assets/creative/bowser-castle.png",
      embedUrl: "https://sketchfab.com/models/3610c2690d0a475d95a4ebd900a7c9b1/embed",
    },
    {
      title: "Nintendo Switch Controller",
      description: "A hard-surface modeling study recreating a Nintendo Switch controller with attention to clean topology for realistic lighting and renders.",
      image: "/assets/creative/switch-controller.png",
      embedUrl: "https://sketchfab.com/models/2d59b06407c642919818f42fdc151989/embed",
    },
];

export default blenderProjects;
